import { createSlice } from "@reduxjs/toolkit";

const allItemsSlice =  createSlice({
    name: 'allItems',
    initialState : [],
    reducers: {
        addInitialItems :(state, action) => {
            return action.payload;
        }
    }
});
export const allItemsActions = allItemsSlice.actions;
export default allItemsSlice;